import { AutoSuggestItem } from "../../AutoSuggestResponse";
import EntityType from "../../EntityType";

export const buildGetItemUrl = (employeeLogin: string): string => {
  return `/api/v1/search?q=${employeeLogin}`;
};

export const buildSuggestItem = (itemResponse: any): AutoSuggestItem => {
  return itemResponse;
};
export const getBusinessTitleFromSuggestItem = (
  suggestItem: AutoSuggestItem
): string => {
  if (
    suggestItem &&
    suggestItem.attributes &&
    suggestItem.attributes.employeeBusinessTitle
  ) {
    return suggestItem.attributes.employeeBusinessTitle;
  }

  console.error("Unable to get employee business title");

  return suggestItem.urlId;
};
